import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-time-projects',
  templateUrl: './time-projects.component.html',
  styleUrls: ['./time-projects.component.css']
})
export class TimeProjectsComponent implements OnInit {
    public itemsListTimeProjects: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadTimeProjects() {
        this.itemsListTimeProjects = await this.datatask.Post(51, {
            cust_name: 'ALL',
            project_keyno: '0',
            ok: '0'
        });
    }

    private async init() {
        this.loadTimeProjects();
    }

    ngOnInit() {
        this.init();
    }
}
